import { Modal } from '@mui/material';
import * as S from './LearnMoreModal.styled';
import ColorfulBtn from '../BookACallButton/colorfulBtn';

type Props = {
    open: boolean;
    handleClose: () => void;
    openCloseVideoModal: () => void;
    actionButton: () => void;
    openCloseCalendarModal?: () => void;
    handleCalendlySchedule?: (id: number) => void;
    superAdminId?: number;
};

const LearnMoreModal = ({
    open,
    handleClose,
    openCloseVideoModal,
    actionButton,
    openCloseCalendarModal,
    handleCalendlySchedule,
    superAdminId,
}: Props) => {
    return (
        <>
            {open && (
                <Modal sx={{ zIndex: '9000' }} open={open} onClose={handleClose}>
                    <S.ModalWrapper>
                        <S.Modal>
                            <S.Container>
                                <S.Text>
                                    <S.NoWrap>If you want to learn more</S.NoWrap>{' '}
                                    <S.NoWrap>about a specific visa option,</S.NoWrap>{' '}
                                    <S.NoWrap>and to get tailored advice,</S.NoWrap>{' '}
                                    <S.NoWrap>book a call with us today!</S.NoWrap>
                                </S.Text>
                                <S.ButtonContainer>
                                    <S.Button
                                        // secondarybtn={true}
                                        onClick={() => {
                                            openCloseVideoModal();
                                        }}
                                    >
                                        <S.PlayIcon />
                                        Watch Video!
                                    </S.Button>
                                    <ColorfulBtn payVisaFee={actionButton} />
                                </S.ButtonContainer>
                                <S.ModalButtonWrapper>
                                    <S.IconBtn onClick={handleClose}>
                                        <S.CrossSimpleIcon />
                                    </S.IconBtn>
                                </S.ModalButtonWrapper>
                            </S.Container>
                        </S.Modal>
                    </S.ModalWrapper>
                </Modal>
            )}
        </>
    );
};

export default LearnMoreModal;
